<!-- Floating chat button -->
<button class="chat-fab" (click)="toggle()" *ngIf="helpAvailable || opsAvailable"
        [class.open]="isOpen" aria-label="Open AI assistant">
  <span *ngIf="!isOpen">💬</span>
  <span *ngIf="isOpen">✕</span>
</button>

<!-- Chat panel -->
<div class="chat-panel" *ngIf="isOpen" role="dialog" aria-label="AI Assistant">

  <!-- Header -->
  <div class="chat-header">
    <span class="chat-title">AI Assistant</span>
    <button class="chat-close" (click)="toggle()" aria-label="Close">✕</button>
  </div>

  <!-- Agent tabs -->
  <div class="chat-tabs">
    <button class="chat-tab" [class.active]="activeAgent === 'help'"
            (click)="activeAgent = 'help'" *ngIf="helpAvailable">
      📚 Help
    </button>
    <button class="chat-tab" [class.active]="activeAgent === 'ops'"
            (click)="activeAgent = 'ops'" *ngIf="opsAvailable && isAdmin">
      ⚙️ Ops
    </button>
  </div>

  <!-- Messages -->
  <div class="chat-messages" #messagesContainer>
    <div class="chat-empty" *ngIf="currentMessages.length === 0">
      <ng-container *ngIf="activeAgent === 'help'">
        Ask me about features, release notes, UCP-600 checks, billing, or how to use the platform.
      </ng-container>
      <ng-container *ngIf="activeAgent === 'ops'">
        Ask about users, dossiers, failed extractions, system stats, or run ad-hoc queries.
      </ng-container>
    </div>

    <div *ngFor="let msg of currentMessages"
         class="chat-message"
         [class.user]="msg.role === 'user'"
         [class.assistant]="msg.role === 'assistant'">
      <div class="message-content">{{ msg.content }}</div>
    </div>

    <div class="chat-typing" *ngIf="sending">
      <span class="typing-dot"></span>
      <span class="typing-dot"></span>
      <span class="typing-dot"></span>
    </div>
  </div>

  <!-- Input -->
  <div class="chat-input-bar">
    <textarea
      class="chat-input"
      [(ngModel)]="inputMessage"
      (keydown)="onKeydown($event)"
      [placeholder]="activeAgent === 'help' ? 'Ask a question...' : 'Query the system...'"
      [disabled]="sending"
      rows="1"
      aria-label="Message input"
    ></textarea>
    <button class="chat-send" (click)="sendMessage()" [disabled]="sending || !inputMessage.trim()">
      ➤
    </button>
  </div>
</div>
